import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const a1 = Math.floor(Math.random() * 5) + 1;     // a1 ∈ [1,5]
  let r;
  do {
    r = Math.floor(Math.random() * 5) + 1;          // r ∈ [1,5]
  } while (r === 0);

  let n;
  do {
    n = Math.floor(Math.random() * 7) + 3;         // n ∈ [3,9]
  } while (n === 0);

  const Sn = (n / 2) * (2 * a1 + (n - 1) * r);

  return {
    type: "FindNFromSumTask",
    data: { a1, r, Sn, n }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { a1, r, Sn } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny o pierwszym wyrazie{" "}
        <InlineMath math={`a_1 = ${a1}`} /> i różnicy{" "}
        <InlineMath math={`r = ${r}`} />.
      </p>
      <p>
        Suma pierwszych <InlineMath math="n" /> wyrazów{" "}
        <InlineMath math={`S_n = ${Sn}`} />. Wyznacz <InlineMath math="n" />.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseInt(userAnswer.raw, 10);
  if (isNaN(given)) return false;

  userAnswer.n = data.n; // żeby było widoczne w renderUserAnswer

  return given === data.n;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath math={`n = ${data.n}`} />
  );
}

export function renderExplanation({ data }) {
  const { a1, r, Sn, n } = data;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na sumę <InlineMath math="n" /> wyrazów ciągu arytmetycznego:
      </p>
      <BlockMath math={`S_n = \\frac{n}{2} \\big( 2a_1 + (n-1)r \\big)`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane i rozwiązujemy równanie względem <InlineMath math="n" />:
      </p>
      <BlockMath
        math={`${Sn} = \\frac{n}{2} \\big( 2 \\cdot ${a1} + (n-1) \\cdot ${r} \\big)`}
      />
      <BlockMath
        math={`n = ${n}`}
      />
    </div>
  );
}

export function renderUserAnswer(userAnswer, task) {
  const n = userAnswer?.n ?? task?.data?.n ?? '?';

  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`n = ${userAnswer.raw}`} />;
}
